import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

const NoIndex = ({ children }) => (
  <Fragment>
    <Helmet>
      <meta name="robots" content="noindex, nofollow" />
    </Helmet>
    {children}
  </Fragment>
);

NoIndex.propTypes = {
  children: PropTypes.node.isRequired,
};

export default NoIndex;
